const SocialsLogos = {
  website: "fa-solid fa-globe",
  blog: "fa-solid fa-square-pen",
  youtube: "fa-brands fa-square-youtube",
  twitch: "fa-brands fa-twitch",
  tiktok: "fa-brands fa-tiktok",
  twitter: "fa-brands fa-square-x-twitter",
  bluesky: "fa-brands fa-square-bluesky",
  mastodon: "fa-brands fa-mastodon",
  facebook: "fa-brands fa-square-facebook",
  instagram: "fa-brands fa-square-instagram",
  threads: "fa-brands fa-square-threads",
  linkedin: "fa-brands fa-linkedin",
  podcast: "fa-solid fa-podcast",
  financement: "fa-solid fa-circle-dollar-to-slot",
  autres: "fa-solid fa-brain",
};

module.exports = SocialsLogos;
